<template>
  <div class="adjuntos-list">
    <div v-for="adjunto in adjuntos" :key="adjunto" class="adjunto-item">
      <div class="adjunto-actions">
        <i @click="verAdjunto(adjunto)" class="fa-regular fa-eye fa-lg me-2 text-success"></i>
        <i @click="descargaAdjunto(adjunto)" class="fa-regular fa-download fa-lg text-success"></i>
      </div>
      <div class="adjunto-info">
        <span class="adjunto-nombre">{{ getFilename(adjunto) }}</span>
      </div>
    </div>
    <div v-if="adjuntos.length === 0" class="no-adjuntos">
      <i class="fas fa-info-circle me-2"></i>
      <span>{{ textoNoAdjuntos }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useApi } from "@api/integration";
import { useModalService } from "@/.shared/services/modal-service";
import FileSaver from "file-saver";
import DocumentoVisor from "@/.shared/components/DocumentViewer.vue";
import { getDocumentalFileName as getFilename } from "@/.shared/helpers/documental-file-name-helper";

const props = defineProps({
  adjuntos: {
    type: Array as () => string[],
    required: true,
    default: () => []
  },
  textoNoAdjuntos: {
    type: String,
    required: true
  }
});

const api = useApi();
const modal = useModalService();

async function urlToBlob(ruta: string) {
  const response = await fetch(ruta);
  const data = await response.blob();
  const blob = new Blob([data], { type: "application/pdf;charset=utf-8" });
  return blob;
}

async function verAdjunto(ruta: string) {
  try {
    const tempUrl = await api.callStandardApi("documentosGenerateTempUrl", { showLoading: false }, ruta);
    const file = ruta.split("/").pop();
    const title = `${file}`;
    await modal.showModal(DocumentoVisor, { ruta: tempUrl }, { title: title });
  } catch (error) {
    console.error("Error al generar URL temporal para visualizar adjunto:", error);
  }
}

async function descargaAdjunto(ruta: string) {
  try {
    const tempUrl = await api.callStandardApi("documentosGenerateTempUrl", { showLoading: false }, ruta);
    const blob = await urlToBlob(tempUrl);
    const file = ruta.split("/").pop();
    FileSaver.saveAs(blob, file);
  } catch (error) {
    console.error("Error al descargar adjunto:", error);
  }
}

</script>

<style scoped lang="scss">
.adjuntos-list {
  max-height: 300px;
  overflow-y: auto;
}

.adjunto-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  transition: background-color 0.2s;
  gap: 12px;
}

.adjunto-info {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.adjunto-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.adjunto-actions i {
  cursor: pointer;
}

.adjunto-actions i:hover {
  opacity: 0.7;
}

.adjunto-item:last-child {
  border-bottom: none;
}

.adjunto-nombre {
  font-size: 12px;
  word-break: break-word;
}

.no-adjuntos {
  display: flex;
  align-items: center;
  padding: 16px 0;
  color: var(--text-default-caption);
  font-size: 12px;
  font-style: italic;
}
</style>
